import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  ReadingMaterialError,
  ReadingMaterialInput,
  ReadingMaterialProps,
  stateStatusType,
} from "../store/actionType";
import ReadingMaterialForm from "./components/ReadingMaterialForm";
import { connect, useSelector } from "react-redux";
import { createReadingMaterial } from "../store/action";
import { ApiError } from "components";
interface OwnProps {
  onClose: () => void;
  videoId: string;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateReadingMaterial: React.FC<Props> = ({
  onClose,
  onCreateRM,
  videoId,
}) => {
  const readingMaterialState = useSelector(
    (state: any) => state.readingMaterial?.readingMaterialState
  );
  const [formData, setFormData] = useState<ReadingMaterialInput>({
    description: "",
    pdf: "",
    name: "",
    video_id: "",
    pdfFile: null,
  });
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ReadingMaterialError>({});
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, files } = e.target as HTMLInputElement;

    if (name === "pdf" && files && files.length > 0) {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        pdfFile: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
     if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        name: "Name is required" ,
      }));
    }
     if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        description:"Description is required" ,
      }));
    }
    let uploadedFilename: string | undefined = undefined;
    if (formData.pdfFile) {
      const uploadUrl = `${process.env.REACT_APP_PDF_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", formData.pdfFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload pdf");
      }

      const result = await response.json();
      uploadedFilename = result?.pdfUrl;

      if (!uploadedFilename) {
        console.error("Pdf upload response invalid", result);
        throw new Error("Pdf upload response invalid");
      }
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      const input: ReadingMaterialInput = {
        description: formData.description,
        name: formData.name,
        video_id: videoId,
      };
      if (uploadedFilename) {
        input.pdf = uploadedFilename;
      }
      setLoading(true);
      setSubmitted(true);
      onCreateRM(input);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!submitted) return;

    if (readingMaterialState.isLoading) return;

    if (readingMaterialState.status === stateStatusType.SUCCESS) {
      setApiError(null);
    }

    if (readingMaterialState.status === stateStatusType.FAILED) {
      setApiError(readingMaterialState.error || "Failed to create questions.");
    }

    setSubmitted(false);
  }, [readingMaterialState, submitted]);

  useEffect(() => {
    if (formData?.pdfFile && typeof formData?.pdfFile !== "string") {
      const fileUrl = URL.createObjectURL(formData?.pdfFile);
      setPreviewUrl(fileUrl);

      return () => URL.revokeObjectURL(fileUrl);
    }
  }, [formData?.pdfFile]);
  return (
    <>
      <ReadingMaterialForm
        header="Create Reading Material"
        onClose={onClose}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        loading={loading}
        error={error}
        previewUrl={previewUrl}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreateRM: (input: ReadingMaterialInput) =>
    dispatch(createReadingMaterial(input)),
});

export default connect(null, mapDispatchToProps)(HandleCreateReadingMaterial);
